// extracted by mini-css-extract-plugin
export default {"table":"AboutTable_table__A6qLR"};